import Shadow from '$tablet-app/src/app/components/Shadow';
import { dimensions, palette } from '$tablet-app/src/app/theme';
import { Button } from '@akin-home/buttons/native';
import { font_variant_styles, spacing } from '@akin-home/theme';
import { Platform } from 'react-native';
import styled from 'styled-components/native';

interface ItemChangeData {
  text: string;
  id: string;
}

interface Props {
  id: string;
  text: string;

  onChange(data: ItemChangeData): void;
  onRemove(id: string): void;
}

export const ChecklistFieldItem = (props: Props) => {
  const { id, text, onChange, onRemove } = props;

  const onPressRemove = () => onRemove(id);
  const handleOnChange = (text: string) => onChange({ text, id });

  return (
    <Item>
      <ItemInput value={text} onChangeText={handleOnChange} />
      <ItemButtonContainer>
        <Button icon="times" variant="secondary" onPress={onPressRemove} />
      </ItemButtonContainer>
    </Item>
  );
};

const Item = styled(Shadow)`
  background-color: ${palette.white};
  padding-left: ${spacing[4]}px;
  padding-right: ${spacing[2]}px;

  flex-direction: row;
  align-items: center;
  border-radius: ${dimensions.buttonRadius}px;
  height: 56px;
`;

const ItemInput = styled.TextInput`
  flex: 1;
  min-width: 50px;
  ${Platform.select({ web: 'text-overflow: ellipsis;' })}

  ${font_variant_styles.p.regular}
`;

const ItemButtonContainer = styled.View`
  flex-grow: 0;
`;
